import { TerminalService } from '@app/services/terminal.service';
import { Terminal } from '@app/models/terminal';
import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Firestore } from '@angular/fire/firestore';
import { AuthService } from 'src/app/services/auth.service';
import { MyGeolocation } from '@app/models/MyGeolocation';
import { addDoc, collection, doc, setDoc, updateDoc } from 'firebase/firestore';

@Component({
  selector: 'app-terminal-manage-dialog',
  templateUrl: './terminal-manage-dialog.component.html',
  styleUrls: ['./terminal-manage-dialog.component.css']
})
export class TerminalManageDialogComponent implements OnInit {
  submitting: boolean;
  terminals: Terminal[];
  isNew = false;
  constructor(
    private firestore: Firestore,
    public auth: AuthService,
    private dialogRef: MatDialogRef<TerminalManageDialogComponent>,
    private terminalService: TerminalService,
    @Inject(MAT_DIALOG_DATA) public keySet: Terminal) { }

  async ngOnInit() {
    if (this.keySet.id === '') {
      this.isNew = true;
    }
    if (!this.keySet.isPWA) {
      this.keySet.isPWA = false;
    }
    this.submitting = false;

    this.terminals = await this.terminalService.getTerminals();
  }

  onSubmit() {
    this.submitting = true;
    this.request();
  }

  async request() {
    if (this.isNew) {
      const ref = await addDoc(collection(this.firestore, 'terminals'), this.keySet);
      await updateDoc(ref, { id: ref.id });
    } else {
      await setDoc(doc(this.firestore, 'terminals', this.keySet.id), this.keySet);
    }



    if (this.isNew && this.keySet.isPWA) {
      localStorage.setItem('serialId', this.keySet.serialId);
      // このタイミングで位置情報とNFCReaderの権限をユーザーにリクエスト
      if ( navigator.geolocation ) {
        // 位置情報は現在値取得時に権限リクエストが発生する。
        MyGeolocation.getCurrentPosition().then(async () => {
          // 位置情報の操作が終わり次第NFCリーダーの権限リクエストを行う
          if ('NDEFReader' in window) {
            const ndef = new NDEFReader();
            ndef.scan();
          }
        });
      }
    }
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  setRandomSerial() {
    if (this.keySet.isPWA) {
      const S = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
      const N = 10;

      let randomId: string;
      let index = 0;
      while (index !== -1) {
        randomId = Array.from(Array(N)).map( () => S[Math.floor(Math.random() * S.length)]).join('');
        index = this.terminals.findIndex((terminal) => terminal.serialId === randomId);
      }

      this.keySet.serialId = randomId;
    } else {
      this.keySet.serialId = '';
    }
  }

}
